"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getUtils = getUtils;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _Wapp = require("wapplr-react/dist/common/Wapp");
var _clsx8 = _interopRequireDefault(require("clsx"));
var TWEEN = _interopRequireWildcard(require("@tweenjs/tween.js"));
var _externalContext = _interopRequireDefault(require("common-components/dist/common/components/App/externalContext"));
var _context33 = _interopRequireDefault(require("default-app/dist/common/components/Artwork/context"));
var _withDataChange = _interopRequireDefault(require("default-app/dist/common/components/Artwork/withDataChange"));
var _defaultAppData = require("default-app/dist/common/defaultAppData");
var _defaultAppData2 = _interopRequireDefault(require("../../defaultAppData"));
var _color = _interopRequireDefault(require("color"));
var _context34 = _interopRequireDefault(require("common-components/dist/common/components/Post/context"));
var _excluded = ["n", "d"],
  _excluded2 = ["generatedData"],
  _excluded3 = ["generatedData"];
var style = require("./style_css.js")["default"];
function getUtils(_ref) {
  var randomFunction = _ref.randomFunction;
  var randomVariables = [];
  var initialData = [(0, _objectSpread2["default"])({}, _defaultAppData2["default"].compositions[0])];
  function generatePropsArray(_ref2) {
    var props = _ref2.props,
      length = _ref2.length,
      fullInput = _ref2.fullInput;
    var propsLength = props.reduce(function (cL, _ref3) {
      var n = _ref3.n;
      return n ? cL + n : cL;
    }, 0);
    var computedColorsLength = props.reduce(function (cL, _ref4) {
      var n = _ref4.n;
      return !n ? cL + 1 : cL;
    }, 0);
    var propsResidual = length - propsLength;
    var computedLength = propsResidual > 0 && computedColorsLength > 0 ? Math.floor(propsResidual / computedColorsLength) : 0;
    if (computedColorsLength * computedLength + propsLength < length) {
      computedLength = computedLength + 1;
    }
    return shuffleArray((0, _toConsumableArray2["default"])(props.reduce(function (a, _ref5) {
      var n = _ref5.n,
        d = _ref5.d,
        rest = (0, _objectWithoutProperties2["default"])(_ref5, _excluded);
      var l = n || computedLength;
      if (l > 0) {
        a.push.apply(a, (0, _toConsumableArray2["default"])((0, _toConsumableArray2["default"])(Array(l)).map(function () {
          return fullInput ? (0, _objectSpread2["default"])({
            n: n,
            d: d
          }, rest) : d;
        })));
      }
      return a;
    }, [])));
  }
  function customRandom() {
    if (typeof randomFunction === "function") {
      var n = randomFunction();
      randomVariables.push(n);
      return n;
    }
    throw "[APP] Missing custom random function";
  }
  function shuffleArray(array) {
    var currentIndex = array.length,
      randomIndex;
    while (currentIndex !== 0) {
      randomIndex = randomFunction ? Math.floor(customRandom() * currentIndex) : Math.floor(Math.random() * currentIndex);
      currentIndex--;
      var _ref6 = [array[randomIndex], array[currentIndex]];
      array[currentIndex] = _ref6[0];
      array[randomIndex] = _ref6[1];
    }
    return array;
  }
  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    if (randomFunction) {
      return Math.floor(customRandom() * (max - min + 1)) + min;
    }
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function text2Binary(string) {
    return string.split('').map(function (_char) {
      return _char.charCodeAt(0).toString(2).padStart(8, 0).split("").map(function (n) {
        return Number(n);
      });
    });
  }
  function binary2Text(binary) {
    var binString = '';
    binary.forEach(function (binA) {
      var bin = binA.join("");
      binString += String.fromCharCode(parseInt(bin, 2));
    });
    return binString;
  }
  function chunkString(str, length) {
    return str.match(new RegExp('.{1,' + length + '}', 'g'));
  }
  function chunkArray(inputArray) {
    var perChunk = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 8;
    return inputArray.reduce(function (resultArray, item, index) {
      var chunkIndex = Math.floor(index / perChunk);
      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);
      return resultArray;
    }, []);
  }
  function binaryFromData(_ref7) {
    var data = _ref7.data,
      _ref7$nullColors = _ref7.nullColors,
      nullColors = _ref7$nullColors === void 0 ? ["#263238", "#273238", "#607d8b", "#90a4ae"] : _ref7$nullColors;
    var td = (0, _toConsumableArray2["default"])(data);
    var mergedData = td.reverse().reduce(function (nd, d) {
      if (!nd.find(function (sd) {
        return sd.position.x === d.position.x && sd.position.y === d.position.y && sd.width === d.width && sd.height === d.height;
      })) {
        nd.push(d);
      }
      return nd;
    }, []).sort(function (a, b) {
      var aX = a.position.x;
      var aY = a.position.y;
      var bX = b.position.x;
      var bY = b.position.y;
      return aY > bY ? 1 : aY < bY ? -1 : aX > bX ? 1 : -1;
    });
    return chunkArray(mergedData.map(function (d) {
      return nullColors.indexOf(d.material.color) > -1 ? 0 : 1;
    }));
  }
  function textFromData(p) {
    var binary = binaryFromData(p);
    return binary2Text(binary);
  }
  function getShapes(binary) {
    var shapes = binary.reduce(function (a, v, row) {
      v.forEach(function (bin, column) {
        var ne = [];
        if (bin === 0 && column !== 0) {
          if (binary[row] && binary[row][column - 1] === 0) {
            ne.push([row, column - 1]);
          }
          if (binary[row] && binary[row][column + 1] === 0) {
            ne.push([row, column + 1]);
          }
          if (binary[row - 1] && binary[row - 1][column] === 0) {
            ne.push([row - 1, column]);
          }
          if (binary[row + 1] && binary[row + 1][column] === 0) {
            ne.push([row + 1, column]);
          }
          if (binary[row - 1] && binary[row - 1][column + 1] === 0 && binary[row] && binary[row][column + 1] === 0) {
            ne.push([row - 1, column + 1]);
          }
          if (ne.length) {
            var foundShape = a.find(function (shape) {
              return shape.find(function (_ref8) {
                var _ref9 = (0, _slicedToArray2["default"])(_ref8, 2),
                  r = _ref9[0],
                  c = _ref9[1];
                return ne.find(function (_ref10) {
                  var _ref11 = (0, _slicedToArray2["default"])(_ref10, 2),
                    row = _ref11[0],
                    column = _ref11[1];
                  return r === row && c === column;
                });
              });
            });
            if (foundShape) {
              foundShape.push([row, column]);
            } else {
              a.push([[row, column]]);
            }
          } else {
            a.push([[row, column]]);
          }
        }
      });
      return a;
    }, []);
    shapes = shapes.reduce(function (a, shape) {
      if (shape.length === 1) {
        var foundShape = shapes.find(function (s) {
          return shape !== s && s.length === 1 && s[0][0] === shape[0][0] - 1 && s[0][1] === shape[0][1] - 1;
        });
        if (foundShape) {
          foundShape.push(shape[0]);
        } else {
          a.push(shape);
        }
      } else {
        a.push(shape);
      }
      return a;
    }, []);
    return shapes;
  }
  function getShape(shapes, binary, _ref12) {
    var _ref13 = (0, _slicedToArray2["default"])(_ref12, 2),
      row = _ref13[0],
      column = _ref13[1];
    var foundShape;
    var bin = binary[row] && binary[row][column];
    if (bin === 0 && column !== 0) {
      foundShape = shapes.find(function (shape) {
        return shape.find(function (_ref14) {
          var _ref15 = (0, _slicedToArray2["default"])(_ref14, 2),
            r = _ref15[0],
            c = _ref15[1];
          return r === row && c === column;
        });
      });
    }
    return foundShape;
  }
  function getShapesObject(shapes, binary, rowCols) {
    return rowCols.reduce(function (a, rowcol) {
      var shape = getShape(shapes, binary, rowcol);
      if (shape) {
        if (a.indexOf(shape) === -1) {
          a.push(shape);
        }
      } else {
        a.push(null);
      }
      return a;
    }, []);
  }
  function getShapeIfIsLight(shapes, binary, row, column) {
    if (binary[row] && binary[row][column] === 0) {
      return null;
    }
    var s1 = getShape(shapes, binary, [row, column + 1]);
    var s2s = getShapesObject(shapes, binary, [[row, column + 2], [row - 1, column + 1]]);
    var s3s = getShapesObject(shapes, binary, [[row, column + 2], [row + 1, column + 1]]);
    return binary[row] && binary[row][column + 1] === 0 ? s1 : binary[row - 1] && binary[row - 1][column + 2] === 1 && s2s.length === 1 ? s2s[0] : binary[row + 1] && binary[row + 1][column + 2] === 1 && s3s.length === 1 ? s3s[0] : null;
  }
  function getLightsForShapes(shapes, binary) {
    return binary.reduce(function (o, v, row) {
      v.map(function (bin, column) {
        var isLight = getShapeIfIsLight(shapes, binary, row, column);
        var shapeN = isLight && shapes.indexOf(isLight);
        if (isLight && shapeN > -1) {
          if (!o[shapeN]) {
            o[shapeN] = [];
          }
          o[shapeN].push([row, column]);
        }
      });
      return o;
    }, {});
  }
  function generateData() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$word = props.word,
      word = _props$word === void 0 ? [{
        d: "fxhash 1"
      }, {
        d: "365 days"
      }, {
        d: "birthday"
      }, {
        d: "ceremony"
      }, {
        d: "fxrandom"
      }, {
        d: "everyday"
      }, {
        d: "everyone"
      }, {
        d: "generate"
      }, {
        d: "absolute"
      }, {
        d: "gorgeous"
      }, {
        d: "creative"
      }, {
        d: "original"
      }, {
        d: "inspired"
      }, {
        d: "abstract"
      }, {
        d: "geometry"
      }, {
        d: "contrast"
      }, {
        d: "pixelart"
      }, {
        d: "binary01"
      }, {
        d: "interact"
      }, {
        d: "together"
      }, {
        d: "thankyou"
      }, {
        d: "iloveyou"
      }, {
        d: "protocol"
      }, {
        d: "remember"
      }, {
        d: "sequence"
      }, {
        d: "solution"
      }, {
        d: "software"
      }, {
        d: "terminal"
      }, {
        d: "ultimate"
      }, {
        d: "universe"
      }, {
        d: "surprise"
      }, {
        d: "wireless"
      }, {
        d: "reaction"
      }, {
        d: "momentum"
      }, {
        d: "minimize"
      }, {
        d: "interval"
      }, {
        d: "identity"
      }, {
        d: "grateful"
      }, {
        d: "function"
      }, {
        d: "firewall"
      }, {
        d: "exciting"
      }, {
        d: "entrance"
      }, {
        d: "electric"
      }, {
        d: "dynamics"
      }, {
        d: "creation"
      }, {
        d: "colorful"
      }, {
        d: "building"
      }, {
        d: "analysis"
      }, {
        d: "extended"
      }, {
        d: "ideology"
      }, {
        d: "magnetic"
      }, {
        d: "maximize"
      }, {
        d: "personal"
      }, {
        d: "physical"
      }, {
        d: "positive"
      }, {
        d: "pleasure"
      }, {
        d: "possible"
      }, {
        d: "presence"
      }, {
        d: "precious"
      }, {
        d: "pleasant"
      }, {
        d: "simplify"
      }, {
        d: "straight"
      }, {
        d: "symbolic"
      }, {
        d: "yourself"
      }] : _props$word,
      _props$nullColors = props.nullColors,
      nullColors = _props$nullColors === void 0 ? [{
        d: "#263238",
        name: "Dark Gray"
      }, {
        d: "#607d8b",
        name: "Middle Gray"
      }, {
        d: "#90a4ae",
        name: "Concrete Gray"
      }] : _props$nullColors,
      _props$lightColors = props.lightColors,
      lightColors = _props$lightColors === void 0 ? [{
        d: [{
          d: "#ff9800",
          n: 0
        }, {
          d: "#ff6e40",
          n: 0
        }, {
          d: "#ce93d8",
          n: 0
        }, {
          d: "#ff8a80",
          n: 0
        }, {
          d: "#ff5252",
          n: 0
        }],
        name: "City Lights"
      }, {
        d: [{
          d: "#ff8a65",
          n: 0
        }, {
          d: "#ffa000",
          n: 0
        }, {
          d: "#ffc107",
          n: 0
        }, {
          d: "#ffcdd2",
          n: 0
        }],
        name: "Pastel Roses"
      }, {
        d: [{
          d: "#fa448c",
          n: 0
        }, {
          d: "#fec859",
          n: 0
        }, {
          d: "#491d88",
          n: 0
        }, {
          d: "#331a38",
          n: 0
        }],
        name: "Neon Glow"
      }, {
        d: [{
          d: "#d99202",
          n: 0
        }, {
          d: "#efaa1e",
          n: 0
        }, {
          d: "#fdd349",
          n: 0
        }, {
          d: "#fbbd4e",
          n: 0
        }],
        name: "Gold Light"
      }, {
        d: [{
          d: "#de1305",
          n: 0
        }, {
          d: "#f62417",
          n: 0
        }, {
          d: "#426dfb",
          n: 0
        }, {
          d: "#e7b508",
          n: 0
        }, {
          d: "#5477ee",
          n: 0
        }],
        name: "Constructivist"
      }, {
        d: [{
          d: "#d2fbfb",
          n: 0
        }, {
          d: "#a6e0e3",
          n: 0
        }, {
          d: "#e794fe",
          n: 0
        }, {
          d: "#fe94c3",
          n: 0
        }, {
          d: "#ffa7ce",
          n: 0
        }],
        name: "Candy"
      }] : _props$lightColors,
      _props$landscapeColor = props.landscapeColors,
      landscapeColors = _props$landscapeColor === void 0 ? [[{
        d: "#ffba52",
        name: "Desert"
      }, {
        d: "#1e88e5",
        name: "Clear Sky"
      }], [{
        d: "#ffba52",
        name: "Desert"
      }, {
        d: "#1e56e5",
        name: "Blue Night"
      }], [{
        d: "#5494d9",
        name: "Sea"
      }, {
        d: ["#de5959", "#f57360"],
        name: "Sunset Beach"
      }], [{
        d: "#5494d9",
        name: "Sea"
      }, {
        d: "#1e88e5",
        name: "Clear Sky"
      }], [{
        d: ["#64b1e1", "#83ffff"],
        name: "Laguna"
      }, {
        d: "#45289f",
        name: "Purple Night"
      }], [{
        d: "#0139cc",
        name: "Ocean"
      }, {
        d: "#7743e0",
        name: "Purple Afternoon"
      }], [{
        d: "#0139cc",
        name: "Ocean"
      }, {
        d: "#1e88e5",
        name: "Clear Sky"
      }], [{
        d: ["#7f324e", "#ff80ab"],
        name: "Rose Field",
        exclude: ["iloveyou"]
      }, {
        d: ["#2c1367", "#572039"],
        name: "Starry Sky",
        exclude: ["iloveyou"]
      }], [{
        d: ["#9a5db2", "#d37b86"],
        name: "Lavender Field"
      }, {
        d: "#1e88e5",
        name: "Clear Sky"
      }], [{
        d: ["#64b1e1", "#83ffff"],
        name: "Laguna"
      }, {
        d: ["#2079e7", "#F57360FF"],
        name: "Sunset"
      }], [{
        d: ["#64b1e1", "#83ffff"],
        name: "Laguna"
      }, {
        d: ["#de5959", "#f57360"],
        name: "Sunset Beach"
      }], [{
        d: "#0139cc",
        name: "Ocean"
      }, {
        d: ["#2079e7", "#F57360FF"],
        name: "Sunset"
      }], [{
        d: "#0139cc",
        name: "Ocean"
      }, {
        d: ["#de5959", "#f57360"],
        name: "Sunset Beach"
      }], [{
        d: ["#7f324e", "#ff80ab"],
        name: "Rose Field",
        exclude: ["iloveyou"]
      }, {
        d: "#45289f",
        name: "Purple Night"
      }], [{
        d: ["#9a5db2", "#d37b86"],
        name: "Lavender Field"
      }, {
        d: "#f57360",
        name: "Sunset"
      }]] : _props$landscapeColor;
    var randomWord = word[getRandomInt(0, word.length - 1)];
    var _shuffleArray$ = (0, _slicedToArray2["default"])(shuffleArray(landscapeColors.filter(function (_ref16) {
        var _ref17 = (0, _slicedToArray2["default"])(_ref16, 2),
          groundColor = _ref17[0],
          skyColor = _ref17[1];
        return !(groundColor.exclude && groundColor.exclude.indexOf(randomWord.d) > -1 || skyColor.exclude && skyColor.exclude.indexOf(randomWord.d) > -1);
      }))[0], 2),
      groundColor = _shuffleArray$[0],
      skyColor = _shuffleArray$[1];
    var nullColor = shuffleArray(nullColors)[0];
    var binary = text2Binary(randomWord.d);
    var shapes = getShapes(binary);
    var randomLightColors = shuffleArray(lightColors)[0];
    var lightColorsByLength = generatePropsArray({
      props: randomLightColors.d,
      length: shapes.length,
      fullInput: true
    });
    var gColor = typeof groundColor.d === "object" ? [(0, _color["default"])(groundColor.d[0]), (0, _color["default"])(groundColor.d[1])] : (0, _color["default"])(groundColor.d);
    var sColor = typeof skyColor.d === "object" ? [(0, _color["default"])(skyColor.d[0]), (0, _color["default"])(skyColor.d[1])] : (0, _color["default"])(skyColor.d);
    var ground = Array(4).fill(null).map(function (v, i) {
      if (Array.isArray(gColor)) {
        return gColor[0].mix(gColor[1], 1 / (4 - 1) * i);
      }
      return gColor.darken(i / 10).hex();
    });
    var sky = Array(4).fill(null).map(function (v, i) {
      if (Array.isArray(sColor)) {
        return sColor[0].mix(sColor[1], 1 / (4 - 1) * i);
      }
      return sColor.lighten(i / 10).hex();
    });
    var landscape = [].concat((0, _toConsumableArray2["default"])(sky), (0, _toConsumableArray2["default"])(ground));
    var generatedData = binary.reduce(function (a, v, row) {
      a.push.apply(a, (0, _toConsumableArray2["default"])(v.map(function (bin, column) {
        return {
          width: 1,
          height: 1,
          material: {
            color: landscape[row],
            opacity: 1
          },
          position: {
            x: column,
            y: row
          }
        };
      })));
      return a;
    }, []);
    generatedData.push.apply(generatedData, (0, _toConsumableArray2["default"])(binary.reduce(function (a, v, row) {
      a.push.apply(a, (0, _toConsumableArray2["default"])(v.map(function (bin, column) {
        var isLight = getShapeIfIsLight(shapes, binary, row, column);
        var shapeN = isLight && shapes.indexOf(isLight);
        var lightColor = isLight && shapeN > -1 && lightColorsByLength[shapeN].d;
        if (bin === 0 || isLight) {
          return {
            width: 1,
            height: 1,
            material: {
              color: bin === 0 ? nullColor.d : isLight ? lightColor : null,
              opacity: 1
            },
            position: {
              x: column,
              y: row
            }
          };
        }
        return null;
      }).filter(function (d) {
        return d;
      })));
      return a;
    }, [])));
    var analytics = {
      Word: randomWord.d,
      "Null Color": nullColor.name,
      Ground: groundColor.name,
      Sky: skyColor.name,
      Lights: randomLightColors.name
    };
    var generatedMinMax = {};
    return {
      generatedData: generatedData,
      analytics: analytics,
      generatedMinMax: generatedMinMax
    };
  }
  function generateCompositions(props) {
    if (props !== null && props !== void 0 && props.generateAllWordsToOneAnimation) {
      var word = (props === null || props === void 0 ? void 0 : props.word) || [{
        d: "fxhash 1"
      }, {
        d: "365 days"
      }, {
        d: "birthday"
      }, {
        d: "fxrandom"
      }, {
        d: "everyday"
      }, {
        d: "generate"
      }, {
        d: "gorgeous"
      }, {
        d: "inspired"
      }, {
        d: "abstract"
      }, {
        d: "geometry"
      }, {
        d: "pixelart"
      }, {
        d: "binary01"
      }, {
        d: "together"
      }, {
        d: "thankyou"
      }, {
        d: "iloveyou"
      }];
      var previewGeneratedData = null;
      var previewRest = null;
      var compositions = [];
      var startI = getRandomInt(0, word.length - 1);
      var randomFirst = [].concat((0, _toConsumableArray2["default"])(word.slice(startI, word.length)), (0, _toConsumableArray2["default"])(word.slice(0, startI)));
      randomFirst.forEach(function (w, i) {
        var _generateData = generateData((0, _objectSpread2["default"])({
            word: [w]
          }, props)),
          generatedData = _generateData.generatedData,
          rest = (0, _objectWithoutProperties2["default"])(_generateData, _excluded2);
        var c = (0, _toConsumableArray2["default"])(initialData.map(function (v) {
          return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, v), {}, {
            data: generatedData
          });
        }));
        c[0].animation = ["enableFirstAnimation", "ArrowRight", "ArrowLeft", "ArrowDown", "D"];
        compositions.push(c[0]);
        if (!previewGeneratedData) {
          previewGeneratedData = generatedData;
        }
        if (!previewRest) {
          previewRest = rest;
        }
      });
      return (0, _objectSpread2["default"])({
        compositions: compositions,
        generatedData: previewGeneratedData
      }, previewRest);
    } else {
      var _generateData2 = generateData(props),
        generatedData = _generateData2.generatedData,
        rest = (0, _objectWithoutProperties2["default"])(_generateData2, _excluded3);
      var _compositions = (0, _toConsumableArray2["default"])(initialData.map(function (v) {
        return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, v), {}, {
          data: generatedData
        });
      }));
      _compositions[0].animation = ["enableFirstAnimation", "ArrowRight", "ArrowLeft", "ArrowDown", "D"];
      return (0, _objectSpread2["default"])({
        compositions: _compositions,
        generatedData: generatedData
      }, rest);
    }
  }
  var defaultMaterialProps = {
    color: 0xffffff,
    opacity: 1
  };
  function decimalToHexString(number) {
    if (number < 0) {
      number = 0xFFFFFFFF + number + 1;
    }
    return number.toString(16).toUpperCase();
  }
  function generateMesh(binaryWords, w, h) {
    var materialProps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var object = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    object.setAttribute("width", w);
    object.setAttribute("height", h);
    var fill = materialProps.color || defaultMaterialProps.color;
    if (typeof fill === "number") {
      fill = "#" + decimalToHexString(fill);
    }
    var opacity = materialProps.opacity || defaultMaterialProps.opacity;
    object.setAttribute("style", "fill: " + fill + "; opacity:" + opacity);
    object.userData = {};
    return object;
  }
  function scaleValue(value, from, to) {
    var scale = (to[1] - to[0]) / (from[1] - from[0]);
    var capped = Math.min(from[1], Math.max(from[0], value)) - from[0];
    return Math.floor(capped * scale + to[0]);
  }
  function getElementByRowCol(binaryWords, data, rowCol) {
    var children = (0, _toConsumableArray2["default"])(binaryWords.objects.children);
    return children.reverse().find(function (child) {
      var childUserData = child.userData;
      return childUserData.position.x === rowCol[1] && childUserData.position.y === rowCol[0];
    });
  }
  function getLightElementsFromData(binaryWords, data) {
    var binary = binaryFromData({
      data: data
    });
    var shapes = getShapes(binary);
    var lights = getLightsForShapes(shapes, binary);
    return shapes.map(function (shape, i) {
      var r = [];
      var lightsForThisShape = lights[i.toString()] || [];
      r.push.apply(r, (0, _toConsumableArray2["default"])(lightsForThisShape.map(function (_ref18) {
        var _ref19 = (0, _slicedToArray2["default"])(_ref18, 2),
          row = _ref19[0],
          column = _ref19[1];
        return getElementByRowCol(binaryWords, data, [row, column]);
      })));
      return r;
    }).filter(function (shape) {
      return shape.indexOf(undefined) === -1;
    });
  }
  function getElementsFromData(binaryWords, data) {
    var binary = binaryFromData({
      data: data
    });
    var shapes = getShapes(binary);
    var lights = getLightsForShapes(shapes, binary);
    return shapes.map(function (shape, i) {
      var r = shape.map(function (_ref20) {
        var _ref21 = (0, _slicedToArray2["default"])(_ref20, 2),
          row = _ref21[0],
          column = _ref21[1];
        return getElementByRowCol(binaryWords, data, [row, column]);
      });
      var lightsForThisShape = lights[i.toString()] || [];
      r.push.apply(r, (0, _toConsumableArray2["default"])(lightsForThisShape.map(function (_ref22) {
        var _ref23 = (0, _slicedToArray2["default"])(_ref22, 2),
          row = _ref23[0],
          column = _ref23[1];
        return getElementByRowCol(binaryWords, data, [row, column]);
      })));
      return r;
    }).filter(function (shape) {
      return shape.indexOf(undefined) === -1;
    });
  }
  function addObjects(_x, _x2) {
    return _addObjects.apply(this, arguments);
  }
  function _addObjects() {
    _addObjects = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9(binaryWords, data) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            if (binaryWords.firstAnimationResolve) {
              binaryWords.firstAnimationResolve();
              binaryWords.firstAnimationResolve = null;
            }
            _context9.next = 3;
            return new Promise( /*#__PURE__*/function () {
              var _ref25 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8(resolve) {
                var resolvers, currentData, child, newChild, positions, step, goal, childAnim, newChildAnim, _final, runOnce, addedNewChild, addNewChild, _addNewChild, childPromise, newChildPromise;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _addNewChild = function _addNewChild3() {
                        _addNewChild = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
                          var nc;
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                            while (1) switch (_context7.prev = _context7.next) {
                              case 0:
                                addObjectsWithoutAnimation(binaryWords, data);
                                binaryWords.currentData = currentData;
                                nc = getElementsFromData(binaryWords, data);
                                step = (0, _toConsumableArray2["default"])(Array(nc.length)).map(function (v, i) {
                                  return i + 1;
                                });
                                nc.forEach(function (shape, i) {
                                  var orientation = "y";
                                  var p = -1;
                                  positions.push((0, _toConsumableArray2["default"])(shape.map(function (e) {
                                    return {
                                      x: Number(e.getAttribute("x")),
                                      y: Number(e.getAttribute("y"))
                                    };
                                  })));
                                  var maxO = positions[i].reduce(function (m, v, c) {
                                    if (positions[i][c][orientation] > m) {
                                      return positions[i][c][orientation];
                                    }
                                    return m;
                                  }, 7);
                                  shape.forEach(function (child, c) {
                                    var newPosition = positions[i][c][orientation] + (goal + maxO + 1) * p;
                                    child.setAttribute(orientation, newPosition);
                                  });
                                });
                                _context7.next = 7;
                                return new Promise(function (resolve) {
                                  return setTimeout(resolve, !child.length ? 100 : 0);
                                });
                              case 7:
                                newChild.push.apply(newChild, (0, _toConsumableArray2["default"])(nc));
                                _context7.next = 10;
                                return new Promise(function (resolve) {
                                  return setTimeout(resolve, 100);
                                });
                              case 10:
                                addedNewChild = true;
                              case 11:
                              case "end":
                                return _context7.stop();
                            }
                          }, _callee7);
                        }));
                        return _addNewChild.apply(this, arguments);
                      };
                      addNewChild = function _addNewChild2() {
                        return _addNewChild.apply(this, arguments);
                      };
                      resolvers = [resolve];
                      binaryWords.firstAnimationResolve = function () {
                        resolvers.forEach(function (resolve) {
                          return resolve();
                        });
                        binaryWords.animationBeforeRender = null;
                      };
                      currentData = binaryWords.currentData || [];
                      child = currentData.length ? getElementsFromData(binaryWords, currentData) : [];
                      newChild = [];
                      positions = [];
                      step = (0, _toConsumableArray2["default"])(Array(child.length)).map(function () {
                        return getRandomInt(1, 3);
                      });
                      goal = 6;
                      childAnim = function childAnim() {
                        child.forEach(function (shape, i) {
                          var orientation = "y";
                          var p = -1;
                          shape.forEach(function (child) {
                            var position = Number(child.getAttribute(orientation));
                            child.setAttribute(orientation, position + step[i] * p / 4);
                          });
                        });
                      };
                      newChildAnim = function newChildAnim() {
                        newChild.forEach(function (shape, i) {
                          var orientation = "y";
                          var p = -1;
                          shape.forEach(function (child, c) {
                            var position = positions[i][c];
                            var currentPosition = Number(child.getAttribute(orientation));
                            var newPosition = currentPosition + step[i] * -p / 2;
                            if (newPosition > position[orientation]) {
                              child.setAttribute(orientation, position[orientation]);
                            } else {
                              child.setAttribute(orientation, newPosition);
                            }
                          });
                        });
                      };
                      _final = binaryWords.currentData === data;
                      runOnce = false;
                      binaryWords.animationBeforeRender = function () {
                        if (childAnim) {
                          childAnim();
                        }
                        if (_final && !childAnim || !_final || !runOnce) {
                          if (newChildAnim) {
                            newChildAnim();
                            runOnce = true;
                          }
                        }
                        binaryWords.inactiveTime = 0;
                        binaryWords.startInactiveTime = Date.now();
                      };
                      if (binaryWords.render) {
                        binaryWords.render();
                      }
                      addedNewChild = false;
                      childPromise = new Promise( /*#__PURE__*/function () {
                        var _ref26 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3(resolve) {
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                            while (1) switch (_context3.prev = _context3.next) {
                              case 0:
                                resolvers.push(resolve);
                                if (child.length) {
                                  _context3.next = 4;
                                  break;
                                }
                                _context3.next = 4;
                                return addNewChild();
                              case 4:
                                _context3.next = 6;
                                return Promise.all(child.map( /*#__PURE__*/function () {
                                  var _ref27 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(shape) {
                                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                                      while (1) switch (_context2.prev = _context2.next) {
                                        case 0:
                                          return _context2.abrupt("return", Promise.all(shape.map(function (e) {
                                            return new Promise(function (resolve) {
                                              var _int = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
                                                var orientation, currentPosition;
                                                return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                                                  while (1) switch (_context.prev = _context.next) {
                                                    case 0:
                                                      orientation = "y";
                                                      currentPosition = Number(e.getAttribute(orientation));
                                                      if (Math.abs(currentPosition) > goal) {
                                                        clearInterval(_int);
                                                        resolve();
                                                      }
                                                    case 3:
                                                    case "end":
                                                      return _context.stop();
                                                  }
                                                }, _callee);
                                              })), 100);
                                            });
                                          })));
                                        case 1:
                                        case "end":
                                          return _context2.stop();
                                      }
                                    }, _callee2);
                                  }));
                                  return function (_x12) {
                                    return _ref27.apply(this, arguments);
                                  };
                                }()));
                              case 6:
                                if (!_final) {
                                  _context3.next = 9;
                                  break;
                                }
                                _context3.next = 9;
                                return new Promise(function (resolve) {
                                  return setTimeout(resolve, 1000);
                                });
                              case 9:
                                childAnim = null;
                                if (!child.length) {
                                  _context3.next = 13;
                                  break;
                                }
                                _context3.next = 13;
                                return addNewChild();
                              case 13:
                                resolve();
                              case 14:
                              case "end":
                                return _context3.stop();
                            }
                          }, _callee3);
                        }));
                        return function (_x11) {
                          return _ref26.apply(this, arguments);
                        };
                      }());
                      newChildPromise = new Promise( /*#__PURE__*/function () {
                        var _ref29 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(resolve) {
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                            while (1) switch (_context6.prev = _context6.next) {
                              case 0:
                                resolvers.push(resolve);
                                _context6.next = 3;
                                return new Promise(function (resolve) {
                                  var _int2 = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
                                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                                      while (1) switch (_context4.prev = _context4.next) {
                                        case 0:
                                          if (addedNewChild) {
                                            clearInterval(_int2);
                                            resolve();
                                          }
                                        case 1:
                                        case "end":
                                          return _context4.stop();
                                      }
                                    }, _callee4);
                                  })), 100);
                                });
                              case 3:
                                _context6.next = 5;
                                return Promise.all(newChild.map( /*#__PURE__*/function () {
                                  var _ref31 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(shape, i) {
                                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                                      while (1) switch (_context5.prev = _context5.next) {
                                        case 0:
                                          return _context5.abrupt("return", Promise.all(shape.map(function (e, c) {
                                            return new Promise(function (resolve) {
                                              var orientation = "y";
                                              var position = positions[i][c];
                                              var _int3 = setInterval(function () {
                                                var currentPosition = Number(e.getAttribute(orientation));
                                                if (currentPosition >= position[orientation]) {
                                                  clearInterval(_int3);
                                                  resolve();
                                                }
                                              }, 100);
                                            });
                                          })));
                                        case 1:
                                        case "end":
                                          return _context5.stop();
                                      }
                                    }, _callee5);
                                  }));
                                  return function (_x14, _x15) {
                                    return _ref31.apply(this, arguments);
                                  };
                                }()));
                              case 5:
                                newChildAnim = null;
                                resolve();
                              case 7:
                              case "end":
                                return _context6.stop();
                            }
                          }, _callee6);
                        }));
                        return function (_x13) {
                          return _ref29.apply(this, arguments);
                        };
                      }());
                      _context8.next = 21;
                      return Promise.all([childPromise, newChildPromise]);
                    case 21:
                      binaryWords.currentData = data;
                      binaryWords.animationBeforeRender = null;
                      binaryWords.inactiveTime = 0;
                      binaryWords.startInactiveTime = Date.now();
                      if (binaryWords.render) {
                        binaryWords.render();
                      }
                      binaryWords.firstAnimationResolve = null;
                      resolve();
                    case 28:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              }));
              return function (_x10) {
                return _ref25.apply(this, arguments);
              };
            }());
          case 3:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return _addObjects.apply(this, arguments);
  }
  function addObjectsWithoutAnimation(binaryWords, data) {
    var child = (0, _toConsumableArray2["default"])(binaryWords.objects.children);
    child.forEach(function (child) {
      binaryWords.objects.removeChild(child);
    });
    if (data.length) {
      var positions = data.map(function (d) {
        return d.position;
      });
      var materials = data.map(function (d) {
        return d.material;
      });
      data.forEach(function (d, i) {
        var material = materials[i];
        var position = positions[i];
        var object = generateMesh(binaryWords, d.width, d.height, material);
        object.setAttribute("x", position.x || 0);
        object.setAttribute("y", position.y || 0);
        binaryWords.objects.appendChild(object);
        object.userData.dataIndex = i;
        object.userData.position = {
          x: position.x || 0,
          y: position.y || 0
        };
      });
      binaryWords.currentData = JSON.parse(JSON.stringify(data));
      if (binaryWords.render) {
        binaryWords.render();
      }
    } else {
      binaryWords.currentData = [];
    }
  }
  function setBackground(binaryWords) {
    var background = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#ffffff";
    var parent = binaryWords.parentContainer;
    if (!binaryWords.removeBackground) {
      binaryWords.background.setAttribute("style", "fill: " + background);
      parent.style.background = background;
    } else {
      binaryWords.background.setAttribute("style", "fill: transparent");
      parent.style.removeProperty("background");
    }
  }
  function tweenAnimation(_x3, _x4) {
    return _tweenAnimation.apply(this, arguments);
  }
  function _tweenAnimation() {
    _tweenAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10(binaryWords, data) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return new Promise(function (resolve) {
              var lightElements = getLightElementsFromData(binaryWords, binaryWords.currentData);
              var length = Object.keys(lightElements).length;
              var random = (0, _toConsumableArray2["default"])(Array(length)).map(function () {
                return getRandomInt(0, length - 1);
              });
              var ri = getRandomInt(1, 3);
              var t = 100;
              var i = 0;
              var nr = 0;
              var colors = [];
              lightElements.forEach(function (shape, i) {
                colors.push((0, _toConsumableArray2["default"])(shape.map(function (e) {
                  return (0, _color["default"])(e.style.fill);
                })));
              });
              function update(_ref32) {
                var a = _ref32.a,
                  b = _ref32.b;
                var shape = lightElements[random[i]];
                shape.forEach(function (e, c) {
                  e.style.fill = colors[random[i]][c].lighten(a).hex();
                  e.style.filter = "blur(0.02px)";
                });
              }
              function reset(i, c) {
                lightElements[i][c].style.fill = colors[i][c].hex();
                lightElements[i][c].style.filter = null;
              }
              function resetShape(i) {
                var shape = lightElements[i];
                shape.forEach(function (e, c) {
                  reset(i, c);
                });
              }
              function resetAll() {
                lightElements.forEach(function (shape, i) {
                  resetShape(i);
                });
              }
              var startData = {
                a: 0,
                b: 0
              };
              new TWEEN.Tween(startData).to((0, _objectSpread2["default"])({}, data), t).repeat((length - 1) * ri).onRepeat(function () {
                nr = nr + 1;
                var m = Math.floor(nr / ri) === nr / ri;
                if (m) {
                  resetShape(i);
                  i = i + 1;
                }
              }).onUpdate(function () {
                binaryWords.inactiveTime = 0;
                binaryWords.startInactiveTime = Date.now();
                update((0, _objectSpread2["default"])({}, startData));
              }).easing(TWEEN.Easing.Quadratic.Out).onComplete(function () {
                resetAll();
                binaryWords.inactiveTime = 0;
                binaryWords.startInactiveTime = Date.now();
                resolve();
              }).start();
              binaryWords.tweenAnimation = null;
            });
          case 2:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return _tweenAnimation.apply(this, arguments);
  }
  function animationByControls(_x5, _x6) {
    return _animationByControls.apply(this, arguments);
  }
  function _animationByControls() {
    _animationByControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12(binaryWords, control) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return new Promise(function (resolve) {
              binaryWords.tweenAnimation = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      if (control === "up") {}
                      if (control === "left") {}
                      if (control === "right") {}
                      if (control === "center") {}
                      _context11.next = 6;
                      return tweenAnimation(binaryWords, {
                        a: 0.2,
                        b: 1
                      });
                    case 6:
                      resolve();
                    case 7:
                    case "end":
                      return _context11.stop();
                  }
                }, _callee11);
              }));
            });
          case 2:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return _animationByControls.apply(this, arguments);
  }
  function animationMap(_x7, _x8) {
    return _animationMap.apply(this, arguments);
  }
  function _animationMap() {
    _animationMap = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13(key, _ref24) {
      var binaryWords, nextCompositionIndex, toggleScreenTypeForAnimation;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            binaryWords = _ref24.binaryWords, nextCompositionIndex = _ref24.nextCompositionIndex, toggleScreenTypeForAnimation = _ref24.toggleScreenTypeForAnimation;
            if (!(key === "ArrowDown")) {
              _context13.next = 4;
              break;
            }
            _context13.next = 4;
            return animationByControls(binaryWords, "center");
          case 4:
            if (!(key === "ArrowUp")) {
              _context13.next = 7;
              break;
            }
            _context13.next = 7;
            return animationByControls(binaryWords, "up");
          case 7:
            if (!(key === "ArrowLeft")) {
              _context13.next = 10;
              break;
            }
            _context13.next = 10;
            return animationByControls(binaryWords, "left");
          case 10:
            if (!(key === "ArrowRight")) {
              _context13.next = 13;
              break;
            }
            _context13.next = 13;
            return animationByControls(binaryWords, "right");
          case 13:
            if (!(key === " ")) {
              _context13.next = 16;
              break;
            }
            _context13.next = 16;
            return toggleScreenTypeForAnimation();
          case 16:
            if (key === "enableFirstAnimation") {
              //nothing, it was happened
            }
            if (!(key === "D")) {
              _context13.next = 20;
              break;
            }
            _context13.next = 20;
            return nextCompositionIndex();
          case 20:
          case "end":
            return _context13.stop();
        }
      }, _callee13);
    }));
    return _animationMap.apply(this, arguments);
  }
  function startAnimation(_x9) {
    return _startAnimation.apply(this, arguments);
  }
  function _startAnimation() {
    _startAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17(props) {
      var binaryWords, animation, _props$enableAnimatio, enableAnimationKeys, currentCompositionIndex, enabledKeys;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            binaryWords = props.binaryWords, animation = props.animation, _props$enableAnimatio = props.enableAnimationKeys, enableAnimationKeys = _props$enableAnimatio === void 0 ? [] : _props$enableAnimatio;
            binaryWords.inactiveTime = 0;
            binaryWords.startInactiveTime = Date.now();
            if (!binaryWords.runningAnimation) {
              _context17.next = 7;
              break;
            }
            binaryWords.runningAnimationStop();
            _context17.next = 7;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 100);
            });
          case 7:
            console.log("[APP] Start animation...");
            currentCompositionIndex = binaryWords.compositionIndex;
            enabledKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Space", "D"].concat((0, _toConsumableArray2["default"])(enableAnimationKeys));
            _context17.next = 12;
            return new Promise( /*#__PURE__*/function () {
              var _ref34 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16(resolve) {
                var resolvers;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      resolvers = [resolve];
                      binaryWords.runningAnimationResolve = function () {
                        resolvers.forEach(function (resolve) {
                          return resolve();
                        });
                        binaryWords.runningAnimation = null;
                        binaryWords.runningAnimationResolve = null;
                      };
                      console.log("[APP] Animation scene");
                      if (!animation.length) {
                        _context16.next = 6;
                        break;
                      }
                      _context16.next = 6;
                      return new Promise(function (resolve) {
                        resolvers.push(resolve);
                        setTimeout(resolve, 500);
                      });
                    case 6:
                      _context16.next = 8;
                      return new Promise( /*#__PURE__*/function () {
                        var _ref35 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15(resolve) {
                          var animationIndex, next, _next;
                          return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
                            while (1) switch (_context15.prev = _context15.next) {
                              case 0:
                                _next = function _next3() {
                                  _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14() {
                                    var key, k;
                                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                                      while (1) switch (_context14.prev = _context14.next) {
                                        case 0:
                                          if (binaryWords.runningAnimationResolve) {
                                            _context14.next = 2;
                                            break;
                                          }
                                          return _context14.abrupt("return", resolve());
                                        case 2:
                                          binaryWords.inactiveTime = 0;
                                          binaryWords.startInactiveTime = Date.now();
                                          animationIndex = animationIndex + 1;
                                          if (!(typeof animation[animationIndex] !== "undefined")) {
                                            _context14.next = 24;
                                            break;
                                          }
                                          key = animation[animationIndex];
                                          if (!(key && enabledKeys.indexOf(key) > -1 || key && !isNaN(Number(key)))) {
                                            _context14.next = 20;
                                            break;
                                          }
                                          if (isNaN(Number(key))) {
                                            _context14.next = 14;
                                            break;
                                          }
                                          console.log("[APP] Animation wait:", Number(key));
                                          _context14.next = 12;
                                          return new Promise(function (resolve) {
                                            return setTimeout(resolve, Number(key));
                                          });
                                        case 12:
                                          _context14.next = 20;
                                          break;
                                        case 14:
                                          k = key === "Space" ? " " : key;
                                          console.log("[APP] Animation key:", key);
                                          _context14.next = 18;
                                          return animationMap(k, props);
                                        case 18:
                                          _context14.next = 20;
                                          return new Promise(function (resolve) {
                                            return setTimeout(resolve, 500);
                                          });
                                        case 20:
                                          _context14.next = 22;
                                          return next();
                                        case 22:
                                          _context14.next = 25;
                                          break;
                                        case 24:
                                          resolve();
                                        case 25:
                                        case "end":
                                          return _context14.stop();
                                      }
                                    }, _callee14);
                                  }));
                                  return _next.apply(this, arguments);
                                };
                                next = function _next2() {
                                  return _next.apply(this, arguments);
                                };
                                resolvers.push(resolve);
                                animationIndex = -1;
                                _context15.next = 6;
                                return next();
                              case 6:
                                return _context15.abrupt("return", _context15.sent);
                              case 7:
                              case "end":
                                return _context15.stop();
                            }
                          }, _callee15);
                        }));
                        return function (_x17) {
                          return _ref35.apply(this, arguments);
                        };
                      }());
                    case 8:
                      if (binaryWords.runningAnimationResolve) {
                        binaryWords.runningAnimationResolve();
                      }
                    case 9:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x16) {
                return _ref34.apply(this, arguments);
              };
            }());
          case 12:
            binaryWords.runningAnimation = _context17.sent;
            console.log("[APP] Animation ended", currentCompositionIndex);
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17);
    }));
    return _startAnimation.apply(this, arguments);
  }
  var devComposition = [{
    "width": 36,
    "height": 50,
    "material": {
      "color": "#FFCC99",
      "opacity": 1
    },
    "position": {
      "x": 0,
      "y": 0,
      "z": 0
    }
  }];
  return {
    initialData: initialData,
    shuffleArray: shuffleArray,
    generatePropsArray: generatePropsArray,
    getRandomInt: getRandomInt,
    generateData: generateData,
    generateCompositions: generateCompositions,
    defaultMaterialProps: defaultMaterialProps,
    generateMesh: generateMesh,
    scaleValue: scaleValue,
    addObjects: addObjects,
    addObjectsWithoutAnimation: addObjectsWithoutAnimation,
    setBackground: setBackground,
    startAnimation: startAnimation,
    devComposition: devComposition,
    binary2Text: binary2Text,
    textFromData: textFromData,
    animationByControls: animationByControls
  };
}
function Canvas(props) {
  var context = (0, _react.useContext)(_Wapp.WappContext);
  var externalContext = (0, _react.useContext)(_externalContext["default"]);
  var _externalContext$exte = externalContext.externalSettings,
    externalSettings = _externalContext$exte === void 0 ? {} : _externalContext$exte;
  var randomFunction = externalSettings.randomFunction;
  var wapp = context.wapp;
  wapp.styles.use(style);
  var container = (0, _react.useRef)();
  var centerContainer = (0, _react.useRef)();
  var composition = (0, _react.useRef)();
  var frame = (0, _react.useRef)();
  var objects = (0, _react.useRef)();
  var bg = (0, _react.useRef)();
  var text = (0, _react.useRef)();
  var artworkContext = (0, _react.useContext)(_context33["default"]);
  var postContext = (0, _react.useContext)(_context34["default"]);
  var post = postContext.post;
  var fullPage = props.fullPage,
    parentContainer = props.parentContainer,
    removeBackground = props.removeBackground,
    enableAnimation = props.enableAnimation,
    editor = props.editor,
    _props$disableFirstAn = props.disableFirstAnimation,
    disableFirstAnimation = _props$disableFirstAn === void 0 ? editor : _props$disableFirstAn,
    _props$disableChangeO = props.disableChangeObjectsAnimation,
    disableChangeObjectsAnimation = _props$disableChangeO === void 0 ? editor : _props$disableChangeO,
    _props$disableFirstRu = props.disableFirstRunAnimation,
    disableFirstRunAnimation = _props$disableFirstRu === void 0 ? editor : _props$disableFirstRu,
    _props$disableChangeO2 = props.disableChangeObjectsRunAnimation,
    disableChangeObjectsRunAnimation = _props$disableChangeO2 === void 0 ? editor : _props$disableChangeO2,
    _props$disableAutoSta = props.disableAutoStartAnimationInactivity,
    disableAutoStartAnimationInactivity = _props$disableAutoSta === void 0 ? editor : _props$disableAutoSta,
    enableAnimationKeys = props.enableAnimationKeys,
    useDataChange = props.useDataChange,
    index = props.index,
    onComplete = props.onComplete,
    progressRef = props.progressRef,
    controlsRef = props.controlsRef,
    className = props.className;

  //artworkContext.data.compositions[0].data = devComposition

  var _getUtils = getUtils({
      randomFunction: randomFunction
    }),
    generateCompositions = _getUtils.generateCompositions,
    addObjects = _getUtils.addObjects,
    addObjectsWithoutAnimation = _getUtils.addObjectsWithoutAnimation,
    setBackground = _getUtils.setBackground,
    startAnimation = _getUtils.startAnimation,
    textFromData = _getUtils.textFromData,
    animationByControls = _getUtils.animationByControls;
  var getInitialCompositions = function getInitialCompositions() {
    var _artworkContext$data, _artworkContext$data2;
    if (!((_artworkContext$data = artworkContext.data) !== null && _artworkContext$data !== void 0 && _artworkContext$data.compositions) || (_artworkContext$data2 = artworkContext.data) !== null && _artworkContext$data2 !== void 0 && _artworkContext$data2.compositions && !artworkContext.data.compositions[0]) {
      artworkContext.isGenerated = true;
      if (!artworkContext.data) {
        artworkContext.data = {};
      }
      artworkContext.data.compositions = externalSettings.compositions || generateCompositions().compositions;
    }
    return artworkContext.data.compositions;
  };
  var compositionsString = JSON.stringify(getInitialCompositions());
  var compositions = (0, _react.useMemo)(function () {
    return getInitialCompositions();
  }, [compositionsString]);
  var _useState = (0, _react.useState)(typeof index === "number" && index >= 0 && compositions[index] ? index : 0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    compositionIndex = _useState2[0],
    _setCompositionIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    forceUpdateN = _useState4[0],
    _forceUpdate = _useState4[1];
  var initialSplitScreen = typeof props.splitScreen == "boolean" ? props.splitScreen : false;
  var _useState5 = (0, _react.useState)(initialSplitScreen ? 1 : 0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    screenType = _useState6[0],
    _setScreenType = _useState6[1];
  function setScreenType(_x18) {
    return _setScreenType2.apply(this, arguments);
  }
  function _setScreenType2() {
    _setScreenType2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee28(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee28$(_context28) {
        while (1) switch (_context28.prev = _context28.next) {
          case 0:
            _context28.next = 2;
            return _setScreenType(value);
          case 2:
            binaryWords.screenType = value;
          case 3:
          case "end":
            return _context28.stop();
        }
      }, _callee28);
    }));
    return _setScreenType2.apply(this, arguments);
  }
  function toggleScreenTypeForAnimation() {
    return _toggleScreenTypeForAnimation.apply(this, arguments);
  }
  function _toggleScreenTypeForAnimation() {
    _toggleScreenTypeForAnimation = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee29() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee29$(_context29) {
        while (1) switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return setScreenType(binaryWords.screenType === 0 ? 1 : 0);
          case 2:
          case "end":
            return _context29.stop();
        }
      }, _callee29);
    }));
    return _toggleScreenTypeForAnimation.apply(this, arguments);
  }
  function forceUpdate() {
    return _forceUpdate2.apply(this, arguments);
  }
  function _forceUpdate2() {
    _forceUpdate2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee30() {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee30$(_context30) {
        while (1) switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return _forceUpdate(binaryWords.forceUpdateN + 1);
          case 2:
            binaryWords.forceUpdateN = binaryWords.forceUpdateN + 1;
          case 3:
          case "end":
            return _context30.stop();
        }
      }, _callee30);
    }));
    return _forceUpdate2.apply(this, arguments);
  }
  function setCompositionIndex(_x19) {
    return _setCompositionIndex2.apply(this, arguments);
  }
  function _setCompositionIndex2() {
    _setCompositionIndex2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee31(value) {
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee31$(_context31) {
        while (1) switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return _setCompositionIndex(value);
          case 2:
            binaryWords.compositionIndex = value;
          case 3:
          case "end":
            return _context31.stop();
        }
      }, _callee31);
    }));
    return _setCompositionIndex2.apply(this, arguments);
  }
  function nextCompositionIndex() {
    return _nextCompositionIndex.apply(this, arguments);
  }
  function _nextCompositionIndex() {
    _nextCompositionIndex = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee32() {
      var compositionIndex, newIndex;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee32$(_context32) {
        while (1) switch (_context32.prev = _context32.next) {
          case 0:
            compositionIndex = binaryWords.compositionIndex;
            newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
            if (!(newIndex === compositionIndex)) {
              _context32.next = 7;
              break;
            }
            _context32.next = 5;
            return forceUpdate();
          case 5:
            _context32.next = 9;
            break;
          case 7:
            _context32.next = 9;
            return setCompositionIndex(newIndex);
          case 9:
          case "end":
            return _context32.stop();
        }
      }, _callee32);
    }));
    return _nextCompositionIndex.apply(this, arguments);
  }
  var currentComposition = compositions[compositionIndex];
  var binaryWords = (0, _react.useMemo)(function () {
    var _artworkContext$data3, _artworkContext$data4, _artworkContext$data5, _artworkContext$data6;
    return {
      post: post,
      isGenerated: artworkContext.isGenerated,
      screenType: screenType,
      compositionIndex: compositionIndex,
      forceUpdateN: forceUpdateN,
      parentContainer: parentContainer || container.current,
      renderer: composition.current,
      frame: frame.current,
      enableAnimation: typeof enableAnimation === "boolean" ? enableAnimation : true,
      removeBackground: typeof removeBackground === "boolean" ? removeBackground : false,
      reqId: null,
      removeControlListeners: null,
      maxInactiveTime: 10000,
      inactiveTime: 10000,
      startInactiveTime: Date.now(),
      render: null,
      objects: null,
      background: null,
      viewBox: (_artworkContext$data3 = artworkContext.data) !== null && _artworkContext$data3 !== void 0 && (_artworkContext$data4 = _artworkContext$data3.renderProps) !== null && _artworkContext$data4 !== void 0 && _artworkContext$data4.viewBox && typeof ((_artworkContext$data5 = artworkContext.data) === null || _artworkContext$data5 === void 0 ? void 0 : (_artworkContext$data6 = _artworkContext$data5.renderProps) === null || _artworkContext$data6 === void 0 ? void 0 : _artworkContext$data6.viewBox.startX) === "number" ? artworkContext.data.renderProps.viewBox : {
        startX: 0,
        startY: 0,
        width: 8,
        height: 8
      },
      runningAnimationStop: function runningAnimationStop() {
        if (binaryWords.runningAnimationResolve) {
          console.log("[APP] Animation stopped");
          binaryWords.runningAnimationResolve();
        }
      },
      inactivePromiseExecutor: function inactivePromiseExecutor(resolve) {
        if (binaryWords.inactiveResolve) {
          binaryWords.inactiveResolve();
          binaryWords.inactiveResolve = null;
        }
        binaryWords.inactiveResolve = function () {
          if (binaryWords.inactivePromiseInt) {
            clearInterval(binaryWords.inactivePromiseInt);
          }
          binaryWords.inactiveResolve = null;
          resolve();
        };
        binaryWords.inactivePromiseInt = setInterval( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18() {
          var newIndex;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                binaryWords.inactiveTime = Date.now() - binaryWords.startInactiveTime;
                if (!(binaryWords.maxInactiveTime <= binaryWords.inactiveTime)) {
                  _context18.next = 13;
                  break;
                }
                newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
                binaryWords.inactiveTime = 0;
                binaryWords.startInactiveTime = Date.now();
                if (!(newIndex !== compositionIndex)) {
                  _context18.next = 10;
                  break;
                }
                _context18.next = 8;
                return setCompositionIndex(newIndex);
              case 8:
                _context18.next = 12;
                break;
              case 10:
                _context18.next = 12;
                return forceUpdate();
              case 12:
                binaryWords.inactiveResolve();
              case 13:
              case "end":
                return _context18.stop();
            }
          }, _callee18);
        })), 100);
      },
      showProgress: function () {
        var _showProgress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee19() {
          var _progressRef$current, _progressRef$current$;
          var _ref37,
            _ref37$message,
            message,
            _args19 = arguments;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                _ref37 = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {}, _ref37$message = _ref37.message, message = _ref37$message === void 0 ? "" : _ref37$message;
                if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current = progressRef.current) !== null && _progressRef$current !== void 0 && (_progressRef$current$ = _progressRef$current.actions) !== null && _progressRef$current$ !== void 0 && _progressRef$current$.setShow)) {
                  _context19.next = 4;
                  break;
                }
                _context19.next = 4;
                return progressRef.current.actions.setShow({
                  message: message,
                  value: true
                });
              case 4:
              case "end":
                return _context19.stop();
            }
          }, _callee19);
        }));
        function showProgress() {
          return _showProgress.apply(this, arguments);
        }
        return showProgress;
      }(),
      hideProgress: function () {
        var _hideProgress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee20() {
          var _progressRef$current2, _progressRef$current3;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current2 = progressRef.current) !== null && _progressRef$current2 !== void 0 && (_progressRef$current3 = _progressRef$current2.actions) !== null && _progressRef$current3 !== void 0 && _progressRef$current3.setShow)) {
                  _context20.next = 3;
                  break;
                }
                _context20.next = 3;
                return progressRef.current.actions.setShow({
                  message: "",
                  value: false
                });
              case 3:
              case "end":
                return _context20.stop();
            }
          }, _callee20);
        }));
        function hideProgress() {
          return _hideProgress.apply(this, arguments);
        }
        return hideProgress;
      }(),
      toggleShowControls: function () {
        var _toggleShowControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee21() {
          var _controlsRef$current, _controlsRef$current$;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee21$(_context21) {
            while (1) switch (_context21.prev = _context21.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current = controlsRef.current) !== null && _controlsRef$current !== void 0 && (_controlsRef$current$ = _controlsRef$current.actions) !== null && _controlsRef$current$ !== void 0 && _controlsRef$current$.toggleShow)) {
                  _context21.next = 3;
                  break;
                }
                _context21.next = 3;
                return controlsRef.current.actions.toggleShow();
              case 3:
              case "end":
                return _context21.stop();
            }
          }, _callee21);
        }));
        function toggleShowControls() {
          return _toggleShowControls.apply(this, arguments);
        }
        return toggleShowControls;
      }()
    };
  }, []);
  useDataChange(function (payload) {
    var newCompositions = payload.value.compositions || [];
    if (JSON.stringify(newCompositions) !== compositionsString) {
      forceUpdate();
    }
  });
  (0, _react.useEffect)(function () {
    if (!compositions[compositionIndex]) {
      var newCompositionIndex = compositions[compositionIndex - 1] ? compositionIndex - 1 : 0;
      setCompositionIndex(newCompositionIndex);
    }
  }, [compositionsString, forceUpdateN, compositionIndex]);
  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isCtrl = e.ctrlKey;
      if (isCtrl || !editor) {
        if (e.key === "D" || e.key === "d") {
          e.preventDefault();
          e.stopPropagation();
          binaryWords.runningAnimationStop();
          if (editor) {
            if (compositionIndex === compositions.length - 1) {
              var newComp = generateCompositions().compositions[0];
              compositions.push((0, _objectSpread2["default"])({
                background: currentComposition.background || "#eeac56",
                animation: (0, _toConsumableArray2["default"])(JSON.parse(JSON.stringify(binaryWords.animation || [])))
              }, newComp));
            }
            artworkContext.data.compositions = compositions;
            setCompositionIndex(compositionIndex + 1);
            artworkContext.setData(artworkContext.data, true);
          } else {
            var newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
            if (compositionIndex === newIndex) {
              forceUpdate();
            } else {
              setCompositionIndex(compositions[compositionIndex + 1] ? compositionIndex + 1 : 0);
            }
          }
        }
        if (e.key === "A" || e.key === "a") {
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          setCompositionIndex(compositions[compositionIndex - 1] ? compositionIndex - 1 : compositions.length - 1);
        }
        if (e.key === "ArrowDown") {
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          animationByControls(binaryWords, "center");
        }
        if (e.key === "ArrowUp") {
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          animationByControls(binaryWords, "up");
        }
        if (e.key === "ArrowLeft") {
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          animationByControls(binaryWords, "left");
        }
        if (e.key === "ArrowRight") {
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          animationByControls(binaryWords, "right");
        }
        if (e.key === " ") {
          binaryWords.inactiveTime = 0;
          binaryWords.startInactiveTime = Date.now();
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          setScreenType(screenType + 1 > 2 ? 0 : screenType + 1);
        }
        if (e.key === "5") {
          var save = /*#__PURE__*/function () {
            var _ref38 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee23() {
              var _binaryWords$post, _binaryWords$post2, _binaryWords$post3;
              var svgRenderer, svgRoot, background, serializer, source, svgBlob, svgUrl, downloadLink, dimKeys, width, height, fileName, prepareForServer, _prepareForServer;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee23$(_context23) {
                while (1) switch (_context23.prev = _context23.next) {
                  case 0:
                    _prepareForServer = function _prepareForServer3() {
                      _prepareForServer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee22() {
                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee22$(_context22) {
                          while (1) switch (_context22.prev = _context22.next) {
                            case 0:
                              window.dataForServerSaving = {
                                blob: svgBlob,
                                type: "svg",
                                fileName: fileName
                              };
                              console.log("[APP]", "The data for server saving is ready...");
                            case 2:
                            case "end":
                              return _context22.stop();
                          }
                        }, _callee22);
                      }));
                      return _prepareForServer.apply(this, arguments);
                    };
                    prepareForServer = function _prepareForServer2() {
                      return _prepareForServer.apply(this, arguments);
                    };
                    _context23.next = 4;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 1000);
                    });
                  case 4:
                    console.log("[APP]", "Saving...");
                    _context23.next = 7;
                    return binaryWords.showProgress({
                      message: "Saving..."
                    });
                  case 7:
                    _context23.next = 9;
                    return new Promise(function (resolve) {
                      return setTimeout(resolve, 200);
                    });
                  case 9:
                    if (screenType === 0) {
                      svgRenderer = binaryWords.frame;
                    } else {
                      svgRenderer = binaryWords.renderer;
                    }
                    svgRoot = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svgRoot.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
                    background = currentComposition.background || "#ffffff";
                    svgRoot.setAttribute("style", "background:" + background + ";");
                    svgRoot.setAttribute("width", screenType === 2 ? "8" : "100%");
                    svgRoot.setAttribute("height", screenType === 2 ? "8" : "100%");
                    svgRoot.setAttribute("viewBox", svgRenderer.getAttribute("viewBox"));
                    svgRoot.innerHTML = svgRenderer.innerHTML;
                    serializer = new XMLSerializer();
                    source = serializer.serializeToString(svgRoot);
                    if (!source.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
                      source = source.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
                    }
                    if (!source.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
                      source = source.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
                    }
                    svgBlob = new Blob([source], {
                      type: "image/svg+xml;charset=utf-8"
                    });
                    svgUrl = URL.createObjectURL(svgBlob);
                    downloadLink = document.createElement("a");
                    dimKeys = Object.keys(_defaultAppData.defaultDimensions);
                    width = _defaultAppData.defaultDimensions[dimKeys[0]].width;
                    height = _defaultAppData.defaultDimensions[dimKeys[0]].height;
                    fileName = ["c4rc0", ((_binaryWords$post = binaryWords.post) === null || _binaryWords$post === void 0 ? void 0 : _binaryWords$post.slug) || ((_binaryWords$post2 = binaryWords.post) === null || _binaryWords$post2 === void 0 ? void 0 : _binaryWords$post2._id) || "", binaryWords.isGenerated && (_binaryWords$post3 = binaryWords.post) !== null && _binaryWords$post3 !== void 0 && _binaryWords$post3.hash && binaryWords.post.hash !== binaryWords.post.slug ? binaryWords.post.hash : "", "composition", binaryWords.compositionIndex, binaryWords.screenType > 0 ? "splitscreen" : "", width + "x" + height].filter(function (t) {
                      return t || t === 0;
                    }).join("_");
                    downloadLink.href = svgUrl;
                    downloadLink.download = fileName;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                    binaryWords.inactiveTime = 0;
                    binaryWords.startInactiveTime = Date.now();
                    binaryWords.runningAnimationStop();
                    binaryWords.hideProgress();
                    prepareForServer();
                  case 39:
                  case "end":
                    return _context23.stop();
                }
              }, _callee23);
            }));
            return function save() {
              return _ref38.apply(this, arguments);
            };
          }();
          binaryWords.inactiveTime = 0;
          binaryWords.startInactiveTime = Date.now();
          binaryWords.runningAnimationStop();
          e.preventDefault();
          e.stopPropagation();
          save();
        }
        if (editor) {
          if (e.key === "X") {
            e.preventDefault();
            e.stopPropagation();
            if (compositions.length > 1) {
              compositions.splice(compositionIndex, 1);
              var newCompositionIndex = compositions[compositionIndex - 1] ? compositionIndex - 1 : 0;
              if (newCompositionIndex !== compositionIndex) {
                setCompositionIndex(compositions[compositionIndex - 1] ? compositionIndex - 1 : 0);
              } else {
                forceUpdate();
              }
              artworkContext.setData(artworkContext.data, true);
            }
          }
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [compositionIndex, forceUpdateN, compositionsString, screenType]);
  (0, _react.useEffect)(function () {
    if (wapp.globals.DEV) {
      window.binaryWords = binaryWords;
    }
    if (!binaryWords.parentContainer) {
      binaryWords.parentContainer = container.current;
    }
    function initGraphics() {
      binaryWords.renderer = composition.current;
      binaryWords.frame = frame.current;
      binaryWords.background = bg.current;
      binaryWords.objects = objects.current;
      binaryWords.text = text.current;
      if (binaryWords.frame) {
        binaryWords.frame.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        var frameBg = binaryWords.frame.children[0] && binaryWords.frame.children[0].children[0];
        frameBg.setAttribute("width", "100%");
        frameBg.setAttribute("height", "100%");
        frameBg.setAttribute("fill", "#ffffff");
      }
      if (binaryWords.text) {
        (0, _toConsumableArray2["default"])(binaryWords.text.children).forEach(function (child, i) {
          child.setAttribute("x", i);
          child.setAttribute("y", binaryWords.viewBox.height + 0.25);
        });
      }
      if (binaryWords.renderer) {
        var g = binaryWords.renderer.parentElement;
        g.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        g.setAttribute("viewBox", binaryWords.renderer.getAttribute("viewBox"));
        binaryWords.renderer.setAttribute("viewBox", binaryWords.viewBox.startX + " " + binaryWords.viewBox.startY + " " + binaryWords.viewBox.width + " " + binaryWords.viewBox.height);
        binaryWords.renderer.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        binaryWords.renderer.setAttribute("width", binaryWords.viewBox.width);
        binaryWords.renderer.setAttribute("height", binaryWords.viewBox.height);
        binaryWords.renderer.setAttribute("x", 0);
        binaryWords.background.setAttribute("width", "100%");
        binaryWords.background.setAttribute("height", "100%");
        binaryWords.objects.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        binaryWords.objects.setAttribute("viewBox", binaryWords.renderer.getAttribute("viewBox"));
      }
    }
    binaryWords.render = function (time) {
      if (binaryWords.reqId) {
        cancelAnimationFrame(binaryWords.reqId);
      }
      if (binaryWords.enableAnimation) {
        binaryWords.reqId = requestAnimationFrame(binaryWords.render);
      }
      if (binaryWords.enableAnimation && binaryWords.tweenAnimation) {
        binaryWords.tweenAnimation();
      }
      if (binaryWords.animationBeforeRender) {
        binaryWords.animationBeforeRender();
      }
      TWEEN.update(time);
    };
    function init() {
      initGraphics();
      if (binaryWords.render) {
        binaryWords.render();
      }
    }
    init();
    function onResize() {
      if (!binaryWords.enableAnimation && binaryWords.render) {
        binaryWords.render();
      }
    }
    binaryWords.onResize = onResize;
    function addResizeListeners() {
      if (binaryWords.parentContainer && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(binaryWords.parentContainer);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }
    var removeResizeListeners = addResizeListeners();
    onResize();
    function onClickFunction() {
      return _onClickFunction.apply(this, arguments);
    }
    function _onClickFunction() {
      _onClickFunction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee24() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return binaryWords.toggleShowControls();
            case 2:
            case "end":
              return _context24.stop();
          }
        }, _callee24);
      }));
      return _onClickFunction.apply(this, arguments);
    }
    function findParent(e, p) {
      if (e && e === p) {
        return true;
      }
      if (e && e.parentElement && e.parentElement === p) {
        return true;
      }
      if (e && e.parentElement) {
        return findParent(e.parentElement, p);
      }
    }
    var globalClickListener = function globalClickListener(e) {
      if (binaryWords.parentContainer) {
        var isInsideClick = findParent(e.target, binaryWords.parentContainer);
        if (isInsideClick) {
          onClickFunction();
        }
      }
    };
    window.addEventListener("click", globalClickListener, false);
    return function willUnmount() {
      removeResizeListeners();
      if (binaryWords.removeControlListeners && binaryWords.controls) {
        binaryWords.removeControlListeners();
      }
      if (binaryWords.reqId) {
        cancelAnimationFrame(binaryWords.reqId);
      }
      window.removeEventListener("click", globalClickListener);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var frameSizeY = 1.5;
    var frameSizeX = 1;
    var frameBg = binaryWords.frame.children[0] && binaryWords.frame.children[0].children[0];
    if (screenType === 0) {
      binaryWords.frame.setAttribute("viewBox", binaryWords.viewBox.startX - frameSizeX + " " + (binaryWords.viewBox.startY - frameSizeY) + " " + (binaryWords.viewBox.width + frameSizeX * 2) + " " + (binaryWords.viewBox.height + frameSizeY * 2));
      frameBg.setAttribute("x", -frameSizeX);
      frameBg.setAttribute("y", -frameSizeY);
    } else {
      binaryWords.frame.setAttribute("viewBox", binaryWords.viewBox.startX + " " + binaryWords.viewBox.startY + " " + binaryWords.viewBox.width + " " + binaryWords.viewBox.height);
      frameBg.setAttribute("x", 0);
      frameBg.setAttribute("y", 0);
    }
    if (binaryWords.renderer) {
      if (screenType === 0) {
        binaryWords.renderer.setAttribute("y", -frameSizeY / 3);
      } else {
        binaryWords.renderer.setAttribute("y", "0");
      }
    }
  }, [screenType]);
  (0, _react.useEffect)(function () {
    var _binaryWords$objects;
    var firstRender = !((_binaryWords$objects = binaryWords.objects) !== null && _binaryWords$objects !== void 0 && _binaryWords$objects.children.length);
    var currentComposition = compositions[compositionIndex];
    if (currentComposition) {
      var data = currentComposition.data;
      var background = currentComposition.background;
      setBackground(binaryWords, background);

      // enableAnimation enable requestAnimationFrame
      // disableFirstAnimation disable the element goes in on render
      // disableChangeObjectsAnimation disable elements move between the changing compositions
      // disableFirstRunAnimation disable start animation from data on render
      // disableChangeObjectsRunAnimation disable start animation after composition changing

      var forceEnabledFirstAnimationFromAnimationData = currentComposition.animation && currentComposition.animation[0] === "enableFirstAnimation" && enableAnimationKeys && enableAnimationKeys.indexOf("enableFirstAnimation") > -1 && !disableFirstRunAnimation && firstRender;
      var forceEnabledChangeObjectsAnimationFromAnimationData = currentComposition.animation && currentComposition.animation[currentComposition.animation.length - 1] === "D" && !disableChangeObjectsRunAnimation && !firstRender;
      if (firstRender && disableFirstAnimation && !forceEnabledFirstAnimationFromAnimationData || !firstRender && disableChangeObjectsAnimation && !forceEnabledChangeObjectsAnimationFromAnimationData || !binaryWords.enableAnimation) {
        var asyncTread1 = /*#__PURE__*/function () {
          var _ref39 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee25() {
            var _currentComposition$a;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee25$(_context25) {
              while (1) switch (_context25.prev = _context25.next) {
                case 0:
                  addObjectsWithoutAnimation(binaryWords, data);
                  if (!firstRender) {
                    _context25.next = 5;
                    break;
                  }
                  _context25.next = 4;
                  return binaryWords.hideProgress();
                case 4:
                  console.log("[APP] Add objects...");
                case 5:
                  if (!onComplete) {
                    _context25.next = 9;
                    break;
                  }
                  console.log("[APP] Call onComplete...");
                  _context25.next = 9;
                  return onComplete();
                case 9:
                  if (!(firstRender && !disableFirstRunAnimation || !firstRender && !disableChangeObjectsRunAnimation)) {
                    _context25.next = 13;
                    break;
                  }
                  if (!((_currentComposition$a = currentComposition.animation) !== null && _currentComposition$a !== void 0 && _currentComposition$a.length && binaryWords.enableAnimation)) {
                    _context25.next = 13;
                    break;
                  }
                  _context25.next = 13;
                  return startAnimation({
                    binaryWords: binaryWords,
                    enableAnimationKeys: enableAnimationKeys,
                    animation: currentComposition.animation,
                    toggleScreenTypeForAnimation: toggleScreenTypeForAnimation,
                    nextCompositionIndex: nextCompositionIndex
                  });
                case 13:
                case "end":
                  return _context25.stop();
              }
            }, _callee25);
          }));
          return function asyncTread1() {
            return _ref39.apply(this, arguments);
          };
        }();
        asyncTread1();
      } else {
        var asyncTread2 = /*#__PURE__*/function () {
          var _ref40 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee26() {
            var _currentComposition$a2;
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee26$(_context26) {
              while (1) switch (_context26.prev = _context26.next) {
                case 0:
                  if (!firstRender) {
                    _context26.next = 4;
                    break;
                  }
                  _context26.next = 3;
                  return binaryWords.hideProgress();
                case 3:
                  setTimeout(function () {
                    console.log("[APP] Add objects...");
                  }, 1);
                case 4:
                  _context26.next = 6;
                  return addObjects(binaryWords, data);
                case 6:
                  if (!onComplete) {
                    _context26.next = 10;
                    break;
                  }
                  console.log("[APP] Call onComplete...");
                  _context26.next = 10;
                  return onComplete();
                case 10:
                  if (!(firstRender && !disableFirstRunAnimation || !firstRender && !disableChangeObjectsRunAnimation)) {
                    _context26.next = 14;
                    break;
                  }
                  if (!((_currentComposition$a2 = currentComposition.animation) !== null && _currentComposition$a2 !== void 0 && _currentComposition$a2.length)) {
                    _context26.next = 14;
                    break;
                  }
                  _context26.next = 14;
                  return startAnimation({
                    binaryWords: binaryWords,
                    enableAnimationKeys: enableAnimationKeys,
                    animation: currentComposition.animation,
                    toggleScreenTypeForAnimation: toggleScreenTypeForAnimation,
                    nextCompositionIndex: nextCompositionIndex
                  });
                case 14:
                case "end":
                  return _context26.stop();
              }
            }, _callee26);
          }));
          return function asyncTread2() {
            return _ref40.apply(this, arguments);
          };
        }();
        asyncTread2();
      }
    }
  }, [compositionIndex, forceUpdateN, compositionsString]);
  (0, _react.useEffect)(function () {
    binaryWords.inactiveTime = 0;
    binaryWords.startInactiveTime = Date.now();
    if (!disableAutoStartAnimationInactivity) {
      var run = /*#__PURE__*/function () {
        var _ref41 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee27() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee27$(_context27) {
            while (1) switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return new Promise(binaryWords.inactivePromiseExecutor);
              case 2:
              case "end":
                return _context27.stop();
            }
          }, _callee27);
        }));
        return function run() {
          return _ref41.apply(this, arguments);
        };
      }();
      run();
    }
    return function () {
      if (binaryWords.inactiveResolve) {
        binaryWords.inactiveResolve();
      }
      if (binaryWords.runningAnimationResolve) {
        binaryWords.runningAnimationResolve();
      }
    };
  }, []);
  (0, _react.useEffect)(function () {
    binaryWords.inactiveTime = 0;
    binaryWords.startInactiveTime = Date.now();
    return function () {
      binaryWords.inactiveTime = 0;
      binaryWords.startInactiveTime = Date.now();
    };
  }, [compositionIndex, forceUpdateN, compositionsString]);
  var tx = currentComposition !== null && currentComposition !== void 0 && currentComposition.data ? textFromData({
    data: currentComposition.data
  }) : null;
  var firstRender = !container.current || wapp.getTargetObject() === "node";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx8["default"])(style.canvas, (0, _defineProperty2["default"])({}, style.fullPage, fullPage), (0, _defineProperty2["default"])({}, style.editor, editor), (0, _defineProperty2["default"])({}, style.firstRender, firstRender), (0, _defineProperty2["default"])({}, style.screenTypeFrame, screenType === 0), (0, _defineProperty2["default"])({}, style.screenTypeFull, screenType === 1), (0, _defineProperty2["default"])({}, style.screenTypeOriginal, screenType === 2), (0, _defineProperty2["default"])({}, className, className)),
    ref: container
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: style.center,
    ref: centerContainer
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: style.frame,
    ref: frame
  }, /*#__PURE__*/_react["default"].createElement("g", {
    key: 0
  }, /*#__PURE__*/_react["default"].createElement("rect", null), tx ? /*#__PURE__*/_react["default"].createElement("g", {
    ref: text
  }, tx.split("").map(function (t, i) {
    return /*#__PURE__*/_react["default"].createElement("text", {
      key: i,
      className: style.text,
      dominantBaseline: "middle",
      textAnchor: "middle",
      style: {
        fontSize: "0.5px",
        fontFamily: "Arial, Helvetica, sans-serif"
      },
      transform: "translate(0.5 0)"
    }, t);
  })) : null), /*#__PURE__*/_react["default"].createElement("g", {
    key: 1
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: style.composition,
    ref: composition
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    ref: bg
  }), /*#__PURE__*/_react["default"].createElement("g", {
    ref: objects
  }))))));
}
var _default = (0, _withDataChange["default"])(Canvas);
exports["default"] = _default;